import React, { useState  } from "react";
import { Row, Col, Input, Radio, Form ,Select,Button,Modal,DatePicker} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Evaluation from "./Evaluation";
import { exportMatchPdf } from "./ExportEvaluationPdf";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { useParams } from "react-router-dom";
import useToken from "../Authentication/useToken";
import axios from "axios"; // pour recupere le nom du patient 
import Constants from "../Utils/Constants";




const API_BASE_URL = Constants.SERVER_URL;



dayjs.extend(isoWeek);
const dayMap = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 0,
};



function EvaluationMATCH() {
  const { t } = useTranslation("Evaluations");
  const { patientId  } = useParams(); // récupère l'ID depuis l'URL
    // const { token } = useToken(); // récupération du token d'auth
  
     console.log(" Paramètre URL (id) :", patientId ); // <--- AJOUT ICI
  const getInitialFormData = () => {
      const parsedId = parseInt(patientId, 10);
  return {
    idPatient: isNaN(parsedId) ? null : parsedId,

    // Section Cardio-musculaire
    chairTestSupport: true,
    chairTestCount: "",
    chairTestTime: "", // ✅ Nouveau champ : temps pour répétitions


    // Section Équilibre
    balanceFeetTogether: "",
    balanceSemiTandem: "",
    balanceTandem: "",

    // Section Objectif de marche
    canWalk: undefined,
    walkingTime: "",
    walkingAid: "", // ✅ Nouveau champ : aide technique
  };
  };
   const [isScheduleModalVisible, setIsScheduleModalVisible] = useState(false);
const [programStartDate, setProgramStartDate] = useState(null);
const [frequencyType, setFrequencyType] = useState("auto");
const [customDays, setCustomDays] = useState([]);
const { token } = useToken(); // si pas déjà présent
const [formData, setFormData] = useState(() => getInitialFormData());

const handleCustomConfirm = () => {
  setIsScheduleModalVisible(true); // ✅ Affiche le modal
};


const generateCalendarEvents = () => {
  const startDate = programStartDate;

  if (!startDate || !patientId) {
    console.log("Données manquantes :", { startDate, patientId });
    return [];
  }

  const sessions = [];
  const start = dayjs(startDate);
  let current = start.clone();

  let sessionCount = 10;
  while (sessionCount > 0) {
    const day = current.day();

    const isSessionDay =
      frequencyType === "auto"
        ? true
        : customDays.includes(
            Object.keys(dayMap).find((key) => dayMap[key] === day)
          );

    if (isSessionDay) {
      const startStr = current.hour(14).minute(0).format();
      const endStr = current.hour(15).minute(0).format();

      sessions.push({
        name: "Séance MATCH",
        startDate: startStr,
        endDate: endStr,
        patientId: parseInt(patientId), // ✅ utiliser directement l'ID
        programId: null, // sera peut-être remplacé plus tard si besoin
      });

      sessionCount--;
    }

    current = current.add(1, "day");
  }

  return sessions;
};


const handlePlanifierMatchSessions = async () => {
  const sessions = generateCalendarEvents();

  if (sessions.length === 0) {
    Modal.error({
      title: "Erreur",
      content: "Aucune séance générée. Vérifiez la date et les jours.",
    });
    return;
  }

  try {
    await axios.post(`${API_BASE_URL}/calendar-sessions/from-path`, sessions, {
      headers: { Authorization: `Bearer ${token}` },
    });

    Modal.success({
      title: "Succès",
      content: "Les séances MATCH ont été planifiées.",
    });

    setIsScheduleModalVisible(false);
  } catch (error) {
    console.error("Erreur MATCH séance:", error);
    Modal.error({
      title: "Erreur",
      content: "Impossible d'enregistrer les séances MATCH.",
    });
  }
};
  

  const calculateScores = (formData) => {
    const scoreCM = calculateChairTestScore(formData);
    const scoreBalance = calculateBalanceScore(formData);
    const totalScore = scoreCM + scoreBalance;
    const programColor = getProgramColor(totalScore);

    return {
      cardioMusculaire: scoreCM,
      equilibre: scoreBalance,
      total: totalScore,
      program: programColor,
    };
  };

  const calculateChairTestScore = (formData) => {
    const count = parseInt(formData.chairTestCount);
    const withSupport = formData.chairTestSupport;

    if (isNaN(count) || count === 0) return 0;

    if (withSupport) {
      // Avec appui
      if (count < 5) return 1; // B < 5 levers
      if (count >= 5 && count <= 9) return 2; // C 5-9 levers
      if (count >= 10) return 3; // D ≥ 10 levers
    } else {
      // Sans appui
      if (count >= 3 && count <= 5) return 3; // E 3 à 5 levers
      if (count < 3) return 2; // Si E < 3, accorder le score C (2)
      if (count >= 5 && count <= 9) return 4; // F 5-9 levers
      if (count >= 10) return 5; // G ≥ 10 levers
    }

    return 0;
  };

  const calculateBalanceScore = (formData) => {
    const feetTogether = parseFloat(formData.balanceFeetTogether || 0);
    const semiTandem = parseFloat(formData.balanceSemiTandem || 0);
    const tandem = parseFloat(formData.balanceTandem || 0);

    // Vérifier dans l'ordre selon le document
    if (tandem >= 3) return 4;
    if (semiTandem >= 10) return 3;
    if (semiTandem < 10 && semiTandem > 0) return 2;
    if (feetTogether >= 10) return 1;
    return 0;
  };

  const getProgramColor = (totalScore) => {
    if (totalScore <= 1) return "ROUGE";
    if (totalScore <= 3) return "JAUNE";
    if (totalScore <= 5) return "ORANGE";
    if (totalScore <= 7) return "VERT";
    return "BLEU";
  };

  const buildPayload = (formData, scores, patientId, isBalanceTestEnabled) => {
    return {
      idPatient: patientId,
      chairTestSupport: formData.chairTestSupport ? "with" : "without",
      chairTestCount: parseInt(formData.chairTestCount, 10),
      chairTestTime: parseFloat(formData.chairTestTime || 0), // ✅

      balanceFeetTogether: parseFloat(formData.balanceFeetTogether, 10),
      balanceSemiTandem: isBalanceTestEnabled("balanceSemiTandem")
        ? parseFloat(formData.balanceSemiTandem || 0, 10)
        : 0,
      balanceTandem: isBalanceTestEnabled("balanceTandem")
        ? parseFloat(formData.balanceTandem || 0, 10)
        : 0,
      walkingTime: formData.canWalk ? parseFloat(formData.walkingTime || 0) : 0,
      walkingAid: formData.walkingAid, // ✅

      scores: {
        cardioMusculaire: scores.cardioMusculaire,
        equilibre: scores.equilibre,
        total: scores.total,
        program: scores.program,
      },
    };
  };

  const buildModalContent = (scores, formData) => {
    return (
      <div className="results-container">
        <h3
          style={{
            marginBottom: "20px",
            borderBottom: "1px solid #eee",
            paddingBottom: "10px",
          }}
        >
          {t("title_results_eval_match")}
        </h3>

        <div style={{ marginBottom: "15px" }}>
          <strong>{t("text_individual_scores")} :</strong>
          <p>
            {t("text_cardio_score")} : {scores.cardioMusculaire}/5
          </p>
          <p>
            {t("text_balance_score")} : {scores.equilibre}/4
          </p>
          <p>
            <strong>
              {t("text_total_score")} : {scores.total}/9
            </strong>
          </p>
        </div>

        <div
          style={{
            marginTop: "20px",
            backgroundColor: "#f5f5f5",
            padding: "15px",
            borderRadius: "5px",
          }}
        >
          <p>
            <strong>{t("text_recommended_match_program")} : </strong>
            <span style={{ fontWeight: "bold" }}> {scores.program}</span>
          </p>
        </div>

        {formData.canWalk && formData.walkingTime && (
          <div
            style={{
              marginTop: "20px",
              borderTop: "1px solid #eee",
              paddingTop: "15px",
            }}
          >
            <p>
              {t("text_walk_speed")} : {calculateSpeed(formData.walkingTime)}{" "}
              {t("text_speed_unit")}
            </p>
            <p>
              <strong>
                {t("text_daily_walking_goal")} :{" "}
                {calculateWalkingObjective(formData.walkingTime)} {t("minutes")}
              </strong>
            </p>
          </div>
        )}

        {!formData.canWalk && (
          <div
            style={{
              marginTop: "20px",
              borderTop: "1px solid #eee",
              paddingTop: "15px",
            }}
          >
            <p>
              <strong>{t("text_walking_capacity_to_improve")}</strong>
            </p>
          </div>
        )}
      </div>
    );
  };

  const calculateSpeed = (walkingTime) => {
    const time = parseFloat(walkingTime);
    if (isNaN(time) || time <= 0) return "0.00";
    return (4 / time).toFixed(2);
  };

  const calculateWalkingObjective = (walkingTime) => {
    const time = parseFloat(walkingTime);

    if (isNaN(time) || time < 0 || walkingTime === "") {
      return null;
    }

    if (time === 0) {
      return 10;
    }

    const speed = 4 / time;

    if (speed < 0.4) return 10;
    if (speed >= 0.4 && speed < 0.6) return 15;
    if (speed >= 0.6 && speed < 0.8) return 20;
    if (speed >= 0.8) return 30;

    return null;
  };

  const renderFormFields = (
    formData,
    handleChange,
    errors,
    isBalanceTestEnabled,
    calculateWalkingObjective
  ) => {
    return (
      <>
        {/* Section A: CARDIO-MUSCULAIRE */}
        <h2>{t("title_sectionA")}</h2>
        <Form.Item label={t("label_chair_test")}>
          <div
            style={{ marginBottom: "15px", fontStyle: "italic", color: "#666" }}
          >
            <InfoCircleOutlined style={{ marginRight: "5px" }} />
            {t("info_start_with_support")}
          </div>
          <Radio.Group
            name="chairTestSupport"
            value={formData.chairTestSupport}
            onChange={(e) =>
              handleChange({
                target: { name: "chairTestSupport", value: e.target.value },
              })
            }
          >
            <Radio value={true}>{t("radio_with_support")}</Radio>
            <Radio value={false}>{t("radio_without_support")}</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={t("label_stand_count")}
          validateStatus={errors.chairTestCount ? "error" : ""}
          help={errors.chairTestCount}
        >
          <Input
            name="chairTestCount"
            value={formData.chairTestCount}
            onChange={handleChange}
            placeholder={t("placeholder_stand_count")}
          />
        </Form.Item>
        <Form.Item
  label="Temps pour les répétitions (en secondes)"
  validateStatus={errors.chairTestTime ? "error" : ""}
  help={errors.chairTestTime}
>
  <Input
    name="chairTestTime"
    value={formData.chairTestTime}
    onChange={handleChange}
    placeholder="Ex: 30.5"
    type="number"
    min={0}
  />
</Form.Item>


        {/* Section B: ÉQUILIBRE */}
        <h2>{t("title_SectionB_match_evaluation")}</h2>
        <div
          style={{ marginBottom: "15px", fontStyle: "italic", color: "#666" }}
        >
          <InfoCircleOutlined style={{ marginRight: "5px" }} />
          {t("info_match_evaluation_1")}
          <br />
          <InfoCircleOutlined style={{ marginRight: "5px" }} />
          {t("info_match_evaluation_2")}
        </div>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label={t("label_feet_together")}
              validateStatus={errors.balanceFeetTogether ? "error" : ""}
              help={errors.balanceFeetTogether}
              tooltip="< 10 secondes = Score 0, ≥ 10 secondes = Score 1"
            >
              <Input
                name="balanceFeetTogether"
                value={formData.balanceFeetTogether}
                onChange={handleChange}
                placeholder={t("placeholder_time")}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={t("label_feet_semi_tandem")}
              validateStatus={errors.balanceSemiTandem ? "error" : ""}
              help={errors.balanceSemiTandem}
              tooltip="< 10 secondes = Score 2, ≥ 10 secondes = Score 3"
            >
              <Input
                name="balanceSemiTandem"
                value={formData.balanceSemiTandem}
                onChange={handleChange}
                placeholder={t("placeholder_time")}
                disabled={!isBalanceTestEnabled("balanceSemiTandem")}
              />

                                      {formData.balanceSemiTandem && (
                             <Form.Item
                               label="Quel pied est devant ?"
                               validateStatus={errors.balanceSemiTandemSupport ? "error" : ""}
                               help={errors.balanceSemiTandemSupport}
                             >
                               <Radio.Group
                                 name="balanceSemiTandemSupport"
                                 value={formData.balanceSemiTandemSupport}
                                 onChange={(e) =>
                                   handleChange({
                                     target: { name: "balanceSemiTandemSupport", value: e.target.value },
                                   })
                                 }
                               >
                                 <Radio value="gauche">Gauche</Radio>
                                 <Radio value="droit">Droit</Radio>
                               </Radio.Group>
                             </Form.Item>
                           )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={t("label_feet_tandem")}
              validateStatus={errors.balanceTandem ? "error" : ""}
              help={errors.balanceTandem}
              tooltip="≥ 3 secondes = Score 4"
            >
              <Input
                name="balanceTandem"
                value={formData.balanceTandem}
                onChange={handleChange}
                placeholder={t("placeholder_time")}
                disabled={!isBalanceTestEnabled("balanceTandem")}
              />
              {formData.balanceTandem && (
                              <Form.Item
                                label="Quel pied est devant ?"
                                validateStatus={errors.balanceTandemSupport ? "error" : ""}
                                help={errors.balanceTandemSupport}
                              >
                                <Radio.Group
                                  name="balanceTandemSupport"
                                  value={formData.balanceTandemSupport}
                                  onChange={(e) =>
                                    handleChange({
                                      target: { name: "balanceTandemSupport", value: e.target.value },
                                    })
                                  }
                                >
                                  <Radio value="gauche">Gauche</Radio>
                                  <Radio value="droit">Droit</Radio>
                                </Radio.Group>
                              </Form.Item>
                            )}
                            
            </Form.Item>
          </Col>
        </Row>

        {/* Section C: VITESSE DE MARCHE */}
        <h2>{t("title_SectionC_path_match_evaluation")}</h2>
        <Form.Item label={t("label_match_walk_objective")}>
          <Radio.Group
            value={formData.canWalk}
            onChange={(e) =>
              handleChange({
                target: { name: "canWalk", value: e.target.value },
              })
            }
            style={{ marginBottom: "16px" }}
          >
            <Radio value={true}>{t("radio_patient_can_walk")}</Radio>
            <Radio value={false}>{t("radio_patient_cannot_walk")}</Radio>
          </Radio.Group>

          {formData.canWalk && (
            <Form.Item
              label={t("label_time_needed_walk_4m")}
              validateStatus={errors.walkingTime ? "error" : ""}
              help={errors.walkingTime}
            >
              <Input
                name="walkingTime"
                value={formData.walkingTime}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^\d*\.?\d*$/.test(value)) {
                    handleChange(e);
                  }
                }}
                placeholder={t("walktime_placeholder")}
              />
              {formData.walkingTime && !errors.walkingTime && (
                <div style={{ marginTop: 8, color: "#666" }}>
                  {t("text_walk_speed")} :{" "}
                  {calculateSpeed(formData.walkingTime)} {t("text_speed_unit")}
                  <div style={{ marginTop: 4 }}>
                    <strong>
                      {t("title_walk_objective")} :{" "}
                      {calculateWalkingObjective(formData.walkingTime)}{" "}
                      {t("text_minutes_per_day")}
                    </strong>
                  </div>
                </div>
              )}
            </Form.Item>
          )}
        </Form.Item>
        {formData.canWalk && (
  <Form.Item label="Type d'aide technique utilisée">
    <Radio.Group
      name="walkingAid"
      value={formData.walkingAid}
      onChange={(e) =>
        handleChange({
          target: { name: "walkingAid", value: e.target.value },
        })
      }
    >
      <Radio value="aucune">Aucune aide technique</Radio>
      <Radio value="canne">Canne</Radio>
      <Radio value="marchette">Marchette</Radio>
      <Radio value="deambulateur">Déambulateur</Radio>
      <Radio value="autre">Autre</Radio>
    </Radio.Group>
  </Form.Item>
)}
<Modal
  title="Planification des séances MATCH"
  open={isScheduleModalVisible}
  onCancel={() => setIsScheduleModalVisible(false)}
  footer={null}
  destroyOnClose={true}
>
  <p>
    <strong>Date de début du programme :</strong>{" "}
    {programStartDate
      ? dayjs(programStartDate).format("DD/MM/YYYY")
      : "Aucune date sélectionnée"}
  </p>

  <Form.Item label="Choisir une date de début">
    <DatePicker
      value={programStartDate}
      onChange={(date) => setProgramStartDate(date)}
    />
  </Form.Item>

  <Form.Item label="Fréquence des séances">
    <Radio.Group
      onChange={(e) => setFrequencyType(e.target.value)}
      value={frequencyType}
    >
      <Radio value="auto">1 séance par jour</Radio>
      <Radio value="custom">Choisir les jours manuellement</Radio>
    </Radio.Group>
  </Form.Item>

  {frequencyType === "custom" && (
    <Form.Item label="Jours de la semaine">
      <Select
        mode="multiple"
        value={customDays}
        onChange={setCustomDays}
        placeholder="Sélectionner les jours"
      >
        <Select.Option value="monday">Lundi</Select.Option>
        <Select.Option value="tuesday">Mardi</Select.Option>
        <Select.Option value="wednesday">Mercredi</Select.Option>
        <Select.Option value="thursday">Jeudi</Select.Option>
        <Select.Option value="friday">Vendredi</Select.Option>
      </Select>
    </Form.Item>
  )}

  
</Modal>


      </>
    );
  };

  // fin de ton renderFormFields

  return (
    <>
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <Button
          type="primary"
          onClick={() =>
            document.querySelector('form button[type="submit"]')?.click()
          }
        >
          Créer l’évaluation
        </Button>
      </div>

      <Evaluation
        evaluationType="MATCH"
        getInitialFormData={getInitialFormData}
        calculateScores={calculateScores}
        renderFormFields={renderFormFields}
        buildPayload={buildPayload}
        buildModalContent={buildModalContent}
        exportPdf={exportMatchPdf}
        onCustomConfirm={handleCustomConfirm}
      />
    </>
  );
}

export default EvaluationMATCH;
EvaluationMATCH.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};
